import { render, staticRenderFns } from "./EditFactcheckSeoDialog.vue?vue&type=template&id=3bd192ce"
import script from "./EditFactcheckSeoDialog.vue?vue&type=script&lang=ts"
export * from "./EditFactcheckSeoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports